import * as React from 'react';
import { Provider } from 'react-redux';
import { i18nReducer, loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { combineReducers } from 'redux';

import { AuditReport } from './audit-report';
import { createStore } from '@common/utils/redux';
import { auditReportEN } from './translations/en';
import { auditReportES } from './translations/es';
import { auditReportJA } from './translations/ja';
import { mountReactNode } from '@common/utils/react';

export * from './audit-report';

export const initAuditReportApp = (
  componentId,
  locale,
  yearCharsCount
) => {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
    syncTranslationWithStore(store);
  
    const translation = {
      en: auditReportEN,
      ja: auditReportJA,
      es: auditReportES,
    };
  
    if (!translation[locale]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
  
    mountReactNode(
      <Provider store={store}>
        <AuditReport 
          yearCharsCount={yearCharsCount}
          locale={locale}
        />
      </Provider>,
      document.getElementById(componentId)
    );
  } catch(err) {
    throw err;
  }
};
